import { ModalHandler } from "@lib/ModalHandler";
import { getRandomizedString } from "@lib/util/common";
import { Accessor } from "solid-js";
import {
  clickSaveButton,
  getQuestionHandler,
  waitForRegularSectionPage,
  waitForSOMainMenu,
} from "../form_handlers";
import { clickSurveySection } from "../form_util";

export async function completePostPremierPresets(
  _totalInStock: number,
  modalHandler: Accessor<ModalHandler>
) {
  await fillFeedbackSection(modalHandler);
}

async function fillFeedbackSection(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(/feedback/i, modalHandler, waitForRegularSectionPage, true);
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("textinput", 1, /please provide any feedback/i)?.answer(
    getRandomizedString(["n", ".,/", "a"])
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}
